var __TEMP__ = require('./_baseGetTag.js');var baseGetTag = __REQUIRE_DEFAULT__(__TEMP__);
var __TEMP__ = require('./isObjectLike.js');var isObjectLike = __REQUIRE_DEFAULT__(__TEMP__);

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && baseGetTag(value) == symbolTag);
}

if (!exports.__esModule) Object.defineProperty(exports, "__esModule", { value: true });exports.default = isSymbol;
